/* eslint-disable @next/next/no-img-element */
import SelectableBoxWithOutline from 'components/common/Box/SelectableBoxWithOutline';
import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';

export const BoxWithOptionalNumberedHeading = ({
  number,
  heading = undefined,
  onClickInfoIcon,
  noBorder = false,
  noPadding = false,
  children,
  additionalClassName = '',
}) => {
  return (
    <SelectableBoxWithOutline
      noBorder={noBorder}
      useDefaultPadding={!noPadding}
      additionalClassName={additionalClassName}
    >
      <div className="boxWithOptionalNumberedHeading grid gap-2em fullWidth">
        {heading && (
          <div className="flexRow fullWidth">
            <p className="xlarge xbold noMargin">
              {number ? `${number}. ` : ''}
              {heading}
            </p>
            {onClickInfoIcon && (
              <img
                src={`${ASSET_PREFIX}/images/info-circle.svg`}
                className="infoIcon clickable"
                onClick={onClickInfoIcon}
                alt="more info"
              />
            )}
          </div>
        )}

        {children}

        <style jsx>
          {`
            .infoIcon {
              width: 20px;
              padding: 2px;
              margin: 0 0.3em;
            }
          `}
        </style>
      </div>
    </SelectableBoxWithOutline>
  );
};
